import axios from 'axios'
import { host } from '../../configuraciones'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

const dataInicial = {
    cumplimiento: []
}

//DEFINICIÓN DE MÉTODOS *********************************************************************************************
const GET_ALL_CUMPLIMIENTOS = 'GET_ALL_CUMPLIMIENTOS'
const GET_CUMPLIMIENTO_BY_ID = 'GET_CUMPLIMIENTO_BY_ID'
const POST_CUMPLIMIENTO = 'POST_CUMPLIMIENTO'
const UPDATE_CUMPLIMIENT = 'UPDATE_CUMPLIMIENT'
//*******************************************************************************************************************


//MÉTODOS 
export const getAllCumplimientos = createAsyncThunk(
    GET_ALL_CUMPLIMIENTOS,
    async () => {
        try {
            const fullUrl = host + `CumplimientoNom070/obtenerCumplimiento`
            const res = await axios.get(fullUrl)
            //console.log('Se obtienen los Vehiculos: '+JSON.stringify(res))
            return res
        } catch (error) {
            console.log(error);
        }
    }
)

export const getCumplimientById = createAsyncThunk(
    GET_CUMPLIMIENTO_BY_ID,
    async (id) => {
        try {
            const fullUrl = host + `CumplimientoNom070/obtenerCumplimientoById/${id}`
            const res = await axios.get(fullUrl)
            //console.log('Se obtienen los Coches: '+JSON.stringify(res))
            return res
        } catch (error) {
            console.log(error);
        }
    }
)

export const insertCumplimiento = createAsyncThunk(
    POST_CUMPLIMIENTO,
    async (data) => {
        try {
            const fullUrl = host + `CumplimientoNom070/agregarCumplimiento`
            //alert(JSON.stringify(data))
            const result = await axios.post(fullUrl, data)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)

//****************************************************************************************************************
//EXPORTS DE MÉTODOS
export const metodosCumplimientoSlice = createSlice({

    name: 'metodosCumplimientoSlice',
    initialState: dataInicial,
    reducers: {
    },
    extraReducers: {

        [getAllCumplimientos.fulfilled]: (state, { payload }) => {
            //console.log('PAYLOAD VEHICULOS'+JSON.stringify(payload))
            state.preguntas = payload.data.data

        },
        [getCumplimientById.fulfilled]: (state, { payload }) => {
            //console.log('PAYLOAD COCHES'+JSON.stringify(payload))
            state.preguntas = payload.data.data
        },
        [insertCumplimiento.fulfilled]: (state, { payload }) => {

        },
        //
        //[updateVehiculo.fulfilled]: (state, { payload }) => {
        //
        //},
        //[eliminarVehiculo.fulfilled]: (state, { payload }) => {
        //
        //},

    },

})


export const { } = metodosCumplimientoSlice.actions
export const CumplimientoReducer = metodosCumplimientoSlice.reducer